import { Button } from "@/components/ui/button";
import ThemeImage from "@/components/ThemeImage";
import heroDeveloperDark from "@/assets/hero-developer-dark.webp";
import heroDeveloperLight from "@/assets/hero-developer-light.webp";
const HeroSection = () => {
  return <section className="relative py-16 md:py-24 overflow-hidden [&_*]:!transition-none" aria-labelledby="hero-title">
      {/* Subtle grid background — stronger at top, fading toward bottom */}
      <div
        className="absolute inset-0 pointer-events-none opacity-[0.07] dark:opacity-[0.12]"
        style={{
          backgroundImage: `linear-gradient(to right, hsl(var(--foreground)) 1px, transparent 1px), linear-gradient(to bottom, hsl(var(--foreground)) 1px, transparent 1px)`,
          backgroundSize: '48px 48px',
          WebkitMaskImage: 'linear-gradient(to bottom, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 100%)',
          maskImage: 'linear-gradient(to bottom, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 100%)',
        }}
      />
      <div className="container relative z-10 px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            
            <h1 id="hero-title" className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 tracking-tight">
              High-Performance Websites for Ambitious Founders
            </h1>
            <p className="text-lg md:text-xl text-muted-foreground mb-8 leading-relaxed">
              Launch in 3-7 days. Lightning-fast sites that convert visitors into customers—no
              bloated builders, no slow load times.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button asChild size="lg" className="font-semibold">
                <a href="/meeting">
                  SCHEDULE A CALL
                </a>
              </Button>
              <Button asChild variant="outline" size="lg" className="font-semibold">
                <a href="/quote">
                  GET A QUOTE
                </a>
              </Button>
            </div>
          </div>
          <div className="flex justify-center lg:justify-end">
            <ThemeImage darkSrc={heroDeveloperDark} lightSrc={heroDeveloperLight} alt="Developer working on high-performance website" className="w-full max-w-lg rounded-2xl mx-auto lg:mx-0 border-2 border-foreground" loading="eager" fetchPriority="high" width={512} height={512} />
          </div>
        </div>
      </div>
    </section>;
};
export default HeroSection;